module.exports = __webpack_public_path__ + "fonts/KFOmCnqEu92Fr1Mu4WxKOzY.352cc77.woff2";